import React from "react";
import { twClassNames } from "../helpers/twClassNames";
import { TooltipContainer } from "./Tooltip.jsx";

export interface InlineAlertProps {
    children: React.ReactNode;
    className?: string;
    id?: string;
    dense?: boolean;
    level: "info" | "warning" | "danger" | "success" | "purbo" | "none";
    type?: "primary" | "secondary";
    textClassName?: string;
    icon?: string;
    cta?: React.ReactNode;
    contentClassName?: string;
    onClick?: () => void;
    tooltip?: string;
}

const styles = {
    danger: { icon: "fas fa-exclamation-circle" },
    info: { icon: "fas fa-info-circle" },
    success: { icon: "fas fa-check-circle" },
    warning: { icon: "fas fa-exclamation-triangle" },
    purbo: { icon: "fas fa-info-circle" },
    none: { icon: "fas fa-info-circle" }
};

export default function InlineAlert({
    children,
    className = "",
    textClassName = "",
    id,
    level,
    type = "primary",
    dense = false,
    icon = "",
    cta = null,
    contentClassName = "",
    onClick = () => {},
    tooltip
}: InlineAlertProps) {
    const style = styles[level];
    const iconElement = <i className={twClassNames(icon ? icon : style.icon)}></i>;

    return (
        <div
            className={twClassNames(
                "inlineAlert",
                level !== "none" && level,
                type === "secondary" && "secondary",
                dense && "dense",
                className
            )}
            onClick={onClick}
        >
            <div className={twClassNames("inlineAlertContent", contentClassName)}>
                {tooltip ? (
                    <TooltipContainer
                        type="secondary"
                        placement="top"
                        body={tooltip}
                        customButton={iconElement}
                    />
                ) : (
                    iconElement
                )}
                <div className={twClassNames("inlineAlertText", textClassName)}>{children}</div>
            </div>
            {cta}
        </div>
    );
}
